import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
import { COMPONENT_PRODUCT_LIST } from '~/models/MarkupComponentNames.model';
import { findFilterAssociatedProductList } from '~/utils/filters/findFilterAssociatedProductList';

export function useDetermineStandaloneProductList(
  markupComponents: Ref<BaseMarkupComponent[]>,
) {
  const productListCount = computed(() => {
    return markupComponents.value.filter(
      (c) => c.Component?.toLowerCase() === COMPONENT_PRODUCT_LIST,
    ).length;
  });

  const idOfFirstProductListAfterFilterComponent = computed(() => {
    return findFilterAssociatedProductList(markupComponents.value)?.generatedId;
  });

  const isStandaloneProductList = (componentJson: { generatedId: string }) => {
    if (productListCount.value <= 1) {
      return false;
    }

    if (
      componentJson.generatedId ===
      idOfFirstProductListAfterFilterComponent.value
    ) {
      return false;
    }

    return true;
  };

  return { isStandaloneProductList };
}
